import { apiClient, attachJwt } from "./apiClient";

export function fetchFilterOptions(dateFilter) {
  return apiClient.get(`/api/jobs/filter_options?dateFilter=${dateFilter}`, attachJwt());
}

export function filterJobs(request) {
console.log("Inside filterJobs with request:", request);
  return apiClient.post(`/api/jobs/filter`, request, attachJwt());
}
